import { Component } from '@angular/core';

@Component({
  selector: 'ln-rectange-arrow-svg-icon',
  imports: [],
  templateUrl: './rectange-arrow-svg-icon.component.html',
  styleUrl: './rectange-arrow-svg-icon.component.css',
})
export class RectangeArrowSvgIconComponent {}
